import React from "react";
import { initials, statusSuffix } from "./ticketUtils";

const TicketRow = ({ ticket, selected, showVendor, onPick }) => (
    <div
        className={`vp-tk-msg${selected ? " sel" : ""}`}
        onClick={() => onPick(ticket.key)}
    >
        <span className="vp-tk-av" style={{ background: ticket.color }}>
            {initials(ticket.from)}
        </span>
        <div className="vp-tk-mbody">
            <div className="vp-tk-mr1">
                <span className="vp-tk-mfrom">{ticket.person}</span>
                <span
                    className={`vp-tk-cat c-${statusSuffix(ticket.status)}`}
                    title={
                        ticket.priority
                            ? `Status: ${ticket.status || "—"} · Priority: ${ticket.priority}`
                            : `Status: ${ticket.status || "—"}`
                    }
                >
                    {ticket.status || "—"}
                </span>
                <span className="vp-tk-mtime">{ticket.time}</span>
            </div>
            <div className="vp-tk-mr2">
                <span className="vp-tk-mno">#{ticket.no}</span>
                {showVendor && ticket.vendorName && (
                    <span className="vp-tk-mvendor" title={ticket.vendorName}>
                        {ticket.vendorName}
                    </span>
                )}
            </div>
            {/* the preview gets a line of its own: the row above it identifies
                the ticket, this one says what it is about, and sharing a line
                left the vendor pill squeezed between the two */}
            <div className="vp-tk-mr3">
                <span className="vp-tk-mprev">{ticket.prev}</span>
            </div>
        </div>
    </div>
);

export default TicketRow;
